import { findAirport, type Airport } from "@/lib/airports";

/** A landing represents travel between cities, never a transfer within one city. */
export function isValidFlightRoute(from: string, to: string): boolean {
  const origin = findAirport(from.toUpperCase());
  const destination = findAirport(to.toUpperCase());
  return Boolean(origin && destination && !origin.isCountry && !destination.isCountry &&
    origin.code !== destination.code &&
    !(origin.city === destination.city && origin.country === destination.country));
}

export function flightEndpointLabel(airport: Airport): string {
  return airport.isMetro
    ? `${airport.city} — obszar miejski (${airport.code})`
    : `${airport.city} — ${airport.name} (${airport.code})`;
}